import { screen, cleanup } from '@testing-library/react';
import { createMemoryHistory } from 'history';

import renderComponent from '../../../../helpers/tests/renderComponent';
import { useGetHomeQuery } from '../../api';

import ContentWidget from './Widget';

jest.setTimeout(100000);

const listOne = [
  {
    id: '6265524a-266f-ed11-97b0-0003ff4ccd9a',
    details: 'Dietary and allergen information.',
    expiryDate: '2/1/2023 12:00:00 AM',
    type: 'Normal',
    publishedDate: '11/28/2022 2:07:00 PM',
    title: 'About University Cafe',
    images: [],
    preferences: [],
    languageCode: null,
    matchUserPreferenceCount: 0,
    score: 79,
    reactions: {
      me: null,
      reactions: [],
      total: 0,
    },
  },
];

const listMany = [
  {
    id: '6265524a-266f-ed11-97b0-0003ff4ccd9a',
    details: 'Dietary and allergen information.',
    expiryDate: '2/1/2023 12:00:00 AM',
    type: 'Normal',
    publishedDate: '11/28/2022 2:07:00 PM',
    title: 'About University Cafe',
    images: [],
    preferences: [],
    languageCode: null,
    matchUserPreferenceCount: 0,
    score: 79,
    reactions: {
      me: null,
      reactions: [],
      total: 0,
    },
  },
  {
    id: '9c97d4d3-ce14-ed11-b5cf-0003ff4cb25e',
    details:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla hendrerit suscipit erat quis accumsan. Cras vitae mauris suscipit, volutpat arcu nec, tristique nibh. Etiam ultrices dolor enim. Curabitur id volutpat tortor, nec lacinia mi. Donec gravida, justo et luctus aliquam, urna orci convallis sapien, et dapibus mi metus id quam. Integer mi neque, ornare ac viverra sed, posuere id ante. Ut vehicula, est in porta pretium, lacus odio suscipit ipsum, vel posuere est nibh sed mauris. Nunc vitae dignissim quam, a fringilla sem. Nam sit amet elit vulputate, cursus est ac, vestibulum lectus. Phasellus nisl leo, laoreet at risus vitae, convallis vulputate enim. Sed nibh nunc, scelerisque eu massa ut, vehicula maximus ipsum. Quisque sapien purus, convallis nec convallis a, mollis non lorem.\n\nInteger ac interdum ligula. Nulla tincidunt dui non consectetur congue. Aenean vitae lorem auctor, mattis nunc et, ultrices metus. Sed id erat lorem. In porta ultrices nisi, eu tempus orci molestie nec. Quisque interdum felis nulla. Duis in tellus efficitur, convallis orci id, auctor lorem. Donec non mauris quis nibh finibus tincidunt vitae sodales lorem. Phasellus venenatis purus sed nunc sodales rutrum. Nulla facilisi.\n\nOrci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Integer eu consectetur diam, id vehicula augue. Curabitur ut nulla efficitur, egestas est nec, euismod nulla. Cras a nulla et eros laoreet mattis id sed lacus. Duis aliquet maximus ante eu pulvinar. Vivamus posuere, metus a sagittis mattis, tellus tellus scelerisque metus, vitae gravida ex dui vel nulla. In arcu urna, rutrum non lectus eu, mattis rutrum augue. Aenean in ipsum in magna accumsan ullamcorper. Ut condimentum ex sed consequat semper. Etiam eu felis placerat, pharetra lorem non, elementum nulla. Pellentesque venenatis rutrum finibus. Vestibulum porttitor cursus leo, ac porta magna bibendum non. Phasellus consectetur convallis arcu. Proin rhoncus accumsan rutrum.\n\nPraesent convallis ultricies ipsum sed iaculis. Nam mi nulla, sagittis id quam vel, commodo volutpat augue. Sed ligula augue, posuere vitae est sit amet, fermentum congue eros. Interdum et malesuada fames ac ante ipsum primis in faucibus. Fusce et turpis quis libero elementum commodo et sed ligula. Nullam blandit auctor augue at imperdiet. Interdum et malesuada fames ac ante ipsum primis in faucibus.\n\nVestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Etiam semper lacus in ex efficitur condimentum. Vestibulum tristique urna sed lorem facilisis efficitur. Donec ac accumsan magna. Fusce maximus sem eu pretium mattis. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Phasellus scelerisque eu ipsum sit amet tristique. Suspendisse eget ligula quam.',
    expiryDate: '1/1/0001 12:00:00 AM',
    type: 'Normal',
    publishedDate: '8/5/2022 2:54:00 PM',
    title: 'The incredible app',
    preferences: [],
    reactions: {
      me: null,
      reactions: [],
      total: 0,
    },
  },
  {
    id: 'bf5b67cc-d701-ed11-b5cf-0003ff4cdd18',
    details: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
    expiryDate: '1/1/2028 12:00:00 AM',
    type: 'Normal',
    publishedDate: '7/11/2022 11:41:00 AM',
    title: 'Event for testing purposes',
    reactions: {
      me: null,
      reactions: [],
      total: 0,
    },
  },
  {
    id: 'bf5b67cc-d701-ed11-b5cf-0003ff4cdd18',
    details: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
    expiryDate: '1/1/2028 12:00:00 AM',
    type: 'Normal',
    publishedDate: '7/11/2022 11:41:00 AM',
    title: 'Event for testing purposes 2',
    reactions: {
      me: null,
      reactions: [],
      total: 0,
    },
  },
];

const mockState = {
  Shared: {
    language: {
      currentLanguageCode: 'en-US',
    },
  },
  Core: {
    context: {
      site: {
        id: '123',
      },
    },
  },
};

const getHomeMock = jest.fn();

jest.mock('../../api', () => ({
  useGetHomeQuery: jest.fn(),
  useUpdateContentReactionMutation: () => [() => true],
  useDeleteContentReactionMutation: () => [() => true],
}));

describe('ContentWidget', () => {
  afterAll(() => cleanup());

  describe('on initial render', () => {
    beforeEach(() => {
      (useGetHomeQuery as jest.Mock).mockReturnValue({
        data: listMany,
      });
    });

    renderComponent(ContentWidget, {}, mockState);

    it('should display content', () => {
      expect(screen.getByTestId('widget')).toBeTruthy();
      expect(screen.getByTestId('content-widget-title')).toBeTruthy();
      expect(screen.getByTestId('content-widget-link')).toBeTruthy();
      expect(screen.getByTestId('widget-body')).toBeTruthy();
    });
  });

  describe('on render with one content item', () => {
    beforeEach(() => {
      (useGetHomeQuery as jest.Mock).mockReturnValue({
        data: listOne,
      });
    });

    renderComponent(ContentWidget, null, mockState);

    it("should display content without 'see all'", () => {
      expect(screen.getByTestId('widget')).toBeTruthy();
      expect(screen.getByText('Newsfeed')).toBeTruthy();
      expect(screen.queryByText('See all')).toBeNull();
      expect(screen.getByTestId('widget-body')).toBeTruthy();
    });
  });

  describe('on render without content', () => {
    beforeEach(() => {
      (useGetHomeQuery as jest.Mock).mockReturnValue({
        data: [],
      });
    });

    renderComponent(ContentWidget, null, mockState);

    it('should display placeholder', () => {
      expect(screen.getByTestId('widget')).toBeTruthy();
      expect(screen.getByText('Newsfeed')).toBeTruthy();
      expect(screen.queryByText('See all')).toBeNull();
      expect(screen.getByTestId('widget-placeholder')).toBeTruthy();
    });
  });

  describe('filtering items hidding promotional items', () => {
    beforeEach(() => {
      (useGetHomeQuery as jest.Mock).mockReturnValue({
        data: [
          {
            id: 'acfd7274-7daa-482f-ae1c-bbc4662a6c00',
            details: 'Promotional Event for testing purposes',
            expiryDate: '1/1/2029 14:00:00 AM',
            type: 'Promotional',
            publishedDate: '8/11/2022 11:41:00 AM',
            title: 'Promotional item',
            reactions: {
              me: null,
              reactions: [],
              total: 0,
            },
          },
          ...listMany,
        ],
      });
    });

    renderComponent(ContentWidget, {
      getHome: getHomeMock,
      currentLanguageCode: 'en-US',
      site: { id: '123' },
      history: createMemoryHistory(),
    });

    it('should display items without promotional items', () => {
      expect(screen.getByTestId('widget')).toBeTruthy();
      expect(screen.queryByText('Promotional item')).not.toBeInTheDocument();
    });
  });
});
